import { PhotoUploadDropzone } from "./PhotoUploadDropzone";
import { FacePreviewApprovalCard } from "./FacePreviewApprovalCard";
import { StyleRefsStrip } from "./StyleRefsStrip";
import { Duck3DViewer } from "./Duck3DViewer";
import { BuildProgress } from "./BuildProgress";
import { RenderPending } from "./RenderPending";
import { SignInGate } from "./SignInGate";
import { UploadHoldCard } from "./UploadHoldCard";
import { useAuth } from "../context/AuthContext";
import { uploadHeld } from "../lib/viewHold";

// The main content of the studio for the current step (1 upload, 2 approve render, 3 build / viewer).
export const StudioStage = ({ step, current, actions, loadGallery, setStep }) => {
  const { isAuthed, openAuth } = useAuth();
  if (step === 1) {
    if (!isAuthed) return <SignInGate onSignIn={openAuth} />;
    return <PhotoUploadDropzone onGenerate={actions.generate} loading={actions.uploading} />;
  }
  if (!current) return null;
  if (step === 2) {
    if (uploadHeld(current)) {
      return (
        <UploadHoldCard
          creation={current}
          onUpdate={(data) => {
            actions.keepPhoto(data);
            loadGallery();
          }}
          onBack={() => setStep(1)}
        />
      );
    }
    if (!current.render) {
      return <RenderPending creation={current} onRedo={() => actions.regenerate(current.style, current.figure || "full")} busy={actions.busy} />;
    }
    return (
      <>
        <FacePreviewApprovalCard
          creation={current}
          onApprove={actions.approve}
          onRegenerate={actions.regenerate}
          onVariations={actions.variations}
          onSelect={actions.select}
          onGenerateStyles={actions.generateStyles}
          onSelectStyle={actions.selectStyle}
          onBack={() => setStep(1)}
          onUpdate={(data) => {
            actions.keepPhoto(data);
            loadGallery();
          }}
          busy={actions.busy}
        />
        <StyleRefsStrip refs={current.style_refs} />
      </>
    );
  }
  if (current.build_status === "ready") {
    return (
      <Duck3DViewer
        key={current.id}
        creation={current}
        onUpdate={(data) => {
          actions.keepPhoto(data);
          loadGallery();
        }}
        onNew={actions.reset}
        onBranch={actions.branch}
        busy={actions.busy}
      />
    );
  }
  return (
    <BuildProgress
      creation={current}
      onRetry={actions.approve}
      onRetryStronger={actions.retryStronger}
      onBack={() => setStep(2)}
      onNotify={actions.notify}
      onCancel={actions.cancel}
      onExtend={actions.extend}
      onUpdate={actions.keepPhoto}
    />
  );
};
